/**
 * Spawn regions.
 *
 * The world is Europe, and a new player chooses roughly where on it to found
 * their holding. Choosing a region rather than a coordinate keeps the choice
 * meaningful without demanding map knowledge from someone who has been
 * playing for eleven seconds: each region is a broad area, and the server
 * places the village on the nearest free buildable tile to a jittered point
 * near the region's anchor.
 *
 * The anchor coordinates themselves live server-side in the generated world
 * data, already nudged onto buildable land at bake time. The client only ever
 * needs what is listed here.
 */
export const EUROPE_REGIONS = [
    {
        id: 'iberia',
        name: 'Iberia',
        blurb: 'The western peninsula. Coasts on two seas and a hard frontier.',
    },
    {
        id: 'france',
        name: 'Francia',
        blurb: 'Rich river country between the ocean and the mountains.',
    },
    {
        id: 'isles',
        name: 'The Isles',
        blurb: 'Britain and Ireland. The sea is your moat, and the road of everyone else.',
    },
    {
        id: 'norse',
        name: 'The Northlands',
        blurb: 'Scandinavia. Long coasts, deep forests, far from everything.',
    },
    {
        id: 'empire',
        name: 'The Heartlands',
        blurb: 'The centre of the map. Every road passes through, in both directions.',
    },
    {
        id: 'italy',
        name: 'Italia',
        blurb: 'A narrow, wealthy peninsula commanding the middle sea.',
    },
    {
        id: 'balkans',
        name: 'The Balkans',
        blurb: 'Rough country between three seas, on the road to the east.',
    },
    {
        id: 'rus',
        name: 'The Rus',
        blurb: 'The wide east. Endless land and long marches in every direction.',
    },
];
export const REGION_IDS = EUROPE_REGIONS.map((r) => r.id);
export function isSpawnRegion(id) {
    return REGION_IDS.includes(id);
}
//# sourceMappingURL=regions.js.map